import { Component, OnInit, Input } from '@angular/core';
import { SecToMinPipe } from '../../sec-to-min.pipe';
import * as _ from 'lodash';

@Component({
  selector: 'playlist-duration',
  templateUrl: './playlist-duration.component.html',
  styleUrls: ['./playlist-duration.component.css']
})
export class PlaylistDurationComponent implements OnInit {
  @Input() playlist: any;
  duration: any = '';
  private secToMin: SecToMinPipe
  constructor() {
    this.secToMin = new SecToMinPipe();
  }

  ngOnInit() {
    this.duration = this.secToMin.transform(_.sum(this.playlist.songsLength));
    if(this.duration == "NaN:NaN:NaN"){
      this.duration ="00:00";
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/playlist-duration/playlist-duration.component.ts